import { useEffect, useRef } from "react";

export function SpectrumAnalyzer({ analyser, active, bars = 36, className = "", color = "#34d399" }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let animId;

    const dataArray = analyser ? new Uint8Array(analyser.frequencyBinCount) : null;

    const render = () => {
      const width = canvas.width;
      const height = canvas.height;
      ctx.clearRect(0, 0, width, height);

      if (!active || !analyser || !dataArray) {
        // Idle flat line
        ctx.fillStyle = "rgba(255,255,255,0.12)";
        const barWidth = Math.max(2, (width / bars) - 2);
        for (let i = 0; i < bars; i++) {
          ctx.fillRect(i * (barWidth + 2), height / 2 - 1, barWidth, 2);
        }
        animId = requestAnimationFrame(render);
        return;
      }

      analyser.getByteFrequencyData(dataArray);

      const barWidth = Math.max(2, (width / bars) - 2);
      const step = Math.max(1, Math.floor((dataArray.length * 0.7) / bars));

      for (let i = 0; i < bars; i++) {
        const val = dataArray[i * step] || 0;
        const barHeight = Math.max(2, (val / 255) * height);
        const x = i * (barWidth + 2);
        const y = height - barHeight;

        const gradient = ctx.createLinearGradient(0, height, 0, 0);
        gradient.addColorStop(0, color);
        gradient.addColorStop(0.6, "#fbbf24");
        gradient.addColorStop(1, "#FF3B30");

        ctx.fillStyle = gradient;
        if (typeof ctx.roundRect === "function") {
          ctx.beginPath();
          ctx.roundRect(x, y, barWidth, barHeight, [2, 2, 0, 0]);
          ctx.fill();
        } else {
          ctx.fillRect(x, y, barWidth, barHeight);
        }
      }

      animId = requestAnimationFrame(render);
    };

    render();

    return () => {
      if (animId) cancelAnimationFrame(animId);
    };
  }, [analyser, active, bars, color]);

  return (
    <canvas
      ref={canvasRef}
      width={480}
      height={90}
      className={`w-full h-full ${className}`}
      data-testid="spectrum-analyzer"
    />
  );
}
